module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head_title.a3e8ea00.svg";